export { default as hasPrivileges } from "./hasPrivileges";
export { default as hasAdminPrivileges } from "./hasAdminPrivileges";



// WEBPACK FOOTER //
// ./src/utils/index.js